module.exports = __webpack_public_path__ + "img/card_lie_side.ed59312b.gif";